import clsx from 'clsx';
import styles from '../../RelatedParties.module.scss';
import { caretRight } from '../../../../../../assets/hostedassets';

interface EntityNameCaret {
    disabled?: boolean;
    expanded?: boolean;
    rotated?: boolean;
}

/** Entity icon + name of a Related Party row, with an optional detail line under the name; wrap it in the row's hover tooltip. */
export function EntityNameLabel({
    name,
    iconSrc,
    designation,
    subtitle,
}: {
    name: string;
    iconSrc?: string;
    designation?: string;
    subtitle?: React.ReactNode;
}) {
    const label = (
        <span className={styles.EntityLabel}>
            {iconSrc && <img src={iconSrc} alt="ent" className={styles.EntityLabelIcon} />}
            <span className={styles.Text}>
                <span className={styles.PersonName}>{name}</span>
                {designation && <span className={styles.DesignationText}> ({designation})</span>}
            </span>
        </span>
    );
    if (!subtitle) return label;
    return (
        <span className={styles.EntityLabelStack}>
            {label}
            <span className={styles.EntitySubtitle}>{subtitle}</span>
        </span>
    );
}

/** Name column of a Related Party row: expand caret (omitted when `caret` is absent) and the name pill. */
function EntityNameCell({ caret, children }: { caret?: EntityNameCaret; children: React.ReactNode }) {
    return (
        <div className={styles.EntityNameContainer}>
            {caret && (
                <div
                    className={clsx(styles.Caret, {
                        [styles.Caret_Disabled]: caret.disabled,
                        [styles.Caret_Expanded]: caret.expanded,
                    })}
                >
                    <img
                        className={clsx(styles.CaretImg, { [styles.CaretImg_Rotate]: caret.rotated })}
                        src={caretRight}
                        alt="caret"
                        height={'12px'}
                    />
                </div>
            )}
            <div className={styles.EntityNamePill}>{children}</div>
        </div>
    );
}

export default EntityNameCell;
